export const CHANGE_DATE_BY_TYPE = 'CHANGE_SESSIONS_DATE_BY_TYPE';
export const FETCH_SESSIONS_LIST = 'FETCH_SESSIONS_LIST';
export const SET_CURRENT_PAGE = 'SET_SESSIONS_CURRENT_PAGE';
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE';

const setCurrentPage = (currentPage) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: { currentPage },
  };
};

const changeDateByType = (dateType, date) => {
  return {
    type: CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const fetchSessionsByFilter = (config) => {
  return async (dispatch, getState, { CustomerApi }) => {
    dispatch(fetchSessionsListPending());

    try {
      const {
        AccountSessionHistory: { currentPage, limit, startDate, endDate },
      } = getState();
      const initialConfig = { currentPage, startDate, endDate, limit };

      let { data } = await CustomerApi.getSessionHistory({
        ...initialConfig,
        ...config,
      });
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      dispatch(fetchSessionsListSuccess({ data, isNextPageAvailable }));
    } catch (error) {
      dispatch(fetchSessionsListFailure(error));
      throw error;
    }
  };
};

const fetchSessionsListSuccess = ({ data, isNextPageAvailable }) => {
  return {
    type: `${FETCH_SESSIONS_LIST}_SUCCESS`,
    payload: { data, isNextPageAvailable },
  };
};

const fetchSessionsListPending = () => {
  return {
    type: `${FETCH_SESSIONS_LIST}_PENDING`,
  };
};

const fetchSessionsListFailure = (error) => {
  return {
    type: `${FETCH_SESSIONS_LIST}_FAILURE`,
    payload: { error },
  };
};

const resetToInitialState = () => {
  return {
    type: RESET_TO_INITIAL_STATE,
  };
};

export { changeDateByType, fetchSessionsByFilter, setCurrentPage, resetToInitialState };
